var TranslationKeys;
(function (TranslationKeys) {
    TranslationKeys["ProvablyFairness"] = "PROVABLY_FAIRNESS";
    TranslationKeys["Time"] = "TIME";
    TranslationKeys["RoundId"] = "ROUND_ID";
    TranslationKeys["GameId"] = "GAME_ID";
    TranslationKeys["Count"] = "COUNT";
    TranslationKeys["TotalBet"] = "TOTAL_BET";
    TranslationKeys["LastWin"] = "LAST_WIN";
    TranslationKeys["Game"] = "GAME";
    TranslationKeys["PlayForReal"] = "PLAY_FOR_REAL";
    TranslationKeys["Music"] = "MUSIC";
    TranslationKeys["Sound"] = "SOUND";
    TranslationKeys["WinterMode"] = "WINTER_MODE";
    TranslationKeys["Animations"] = "ANIMATIONS";
    TranslationKeys["BlackMode"] = "BLACK_MODE";
    TranslationKeys["PlayerId"] = "PLAYER_ID";
    TranslationKeys["BetType"] = "BET_TYPE";
    TranslationKeys["LastRounds"] = "LAST_ROUNDS";
    TranslationKeys["Balance"] = "BALANCE";
    TranslationKeys["All"] = "ALL";
    TranslationKeys["Win"] = "WIN";
    TranslationKeys["Lose"] = "LOSE";
    TranslationKeys["MaximumWin"] = "MAXIMUM_WIN";
    TranslationKeys["MinimumBet"] = "MINIMUM_BET";
    TranslationKeys["MaximumBet"] = "MAXIMUM_BET";
    TranslationKeys["Seconds"] = "SECONDS";
    TranslationKeys["PlayNow"] = "PLAY_NOW";
    TranslationKeys["Demo"] = "DEMO";
    TranslationKeys["Play"] = "PLAY";
    TranslationKeys["ResultId"] = "RESULT_ID";
    TranslationKeys["Key"] = "KEY";
    TranslationKeys["CheckHashCode"] = "CHECK_HASH_CODE";
    TranslationKeys["Salt"] = "SALT";
    TranslationKeys["HashCode"] = "HASH_CODE";
    TranslationKeys["Check"] = "CHECK";
    TranslationKeys["AboutHashCode"] = "ABOUT_HASH_CODE";
    TranslationKeys["Ok"] = "OK";
    TranslationKeys["YourConnectionLost"] = "YOUR_CONNECTION_LOST";
    TranslationKeys["PleaseWait"] = "PLEASE_WAIT";
    TranslationKeys["PleaseRefreshPage"] = "PLEASE_REFRESH_PAGE";
    TranslationKeys["SessionWasInterrupted"] = "YOUR_SESSION_WAS_INTERRUPTED";
    TranslationKeys["SessionInterrupted"] = "SESSION_INTERRUPTED";
    TranslationKeys["Reconnect"] = "RECONNECT";
    TranslationKeys["Min"] = "MIN";
    TranslationKeys["Max"] = "MAX";
    TranslationKeys["Odd"] = "ODD";
    TranslationKeys["Bet"] = "BET";
    TranslationKeys["UnderMaintenanceInGame"] = "UNDER_MAINTENANCE_IN_GAME";
    TranslationKeys["MaxWinLimitNote"] = "MAX_WIN_LIMIT_NOTE";
    TranslationKeys["PleaseSelectMarket"] = "PLEASE_SELECT_MARKET";
    TranslationKeys["AutoCashOut"] = "AUTO_CASHOUT";
    TranslationKeys["BetCanceled"] = "BET_CANCELED";
    TranslationKeys["YourBetIsAccepted"] = "YOUR_BET_IS_ACCEPTED";
    TranslationKeys["NotEnoughBalance"] = "NOT_ENOUGH_BALANCE";
    TranslationKeys["WaitForNextRound"] = "WAIT_FOR_NEXT_ROUND";
    TranslationKeys["Upcoming"] = "UPCOMING";
    TranslationKeys["Expired"] = "EXPIRED";
    TranslationKeys["InProcess"] = "IN_PROCESS";
    TranslationKeys["Finished"] = "FINISHED";
    TranslationKeys["MaxPayout"] = "MAX_PAYOUT";
    TranslationKeys["MaxWinPayout"] = "MAX_WIN_PAYOUT";
    TranslationKeys["MaxWinNote"] = "MAX_WIN_NOTE";
    TranslationKeys["FreeBetMaxWinPayout"] = "FREE_BET_MAX_WIN_PAYOUT";
    TranslationKeys["TotalWinByNow"] = "TOTAL_WIN_BY_NOW";
    TranslationKeys["ReceiveDate"] = "RECEIVE_DATE";
    TranslationKeys["ExpirationDate"] = "EXPIRATION_DATE";
    TranslationKeys["FreeBet"] = "FREE_BET";
    TranslationKeys["FreeBets"] = "FREE_BETS";
    TranslationKeys["MinOdd"] = "MIN_ODD";
    TranslationKeys["UseNow"] = "USE_NOW";
    TranslationKeys["UseLater"] = "USE_LATER";
    TranslationKeys["FreeBetInfo"] = "FREE_BET_INFO";
    TranslationKeys["FreeBetsInCost"] = "FREE_BETS_IN_COST";
    TranslationKeys["YouHaveWon"] = "YOU_HAVE_WON";
    TranslationKeys["FreeBetHasEnded"] = "FREE_BET_HAS_ENDED";
    TranslationKeys["YouWillBeNowPlayingWithRealMoney"] = "YOU_WILL_BE_NOW_PLAYING_WITH_REAL_MONEY";
    TranslationKeys["CongratulationsFreeBetsInTotalCost"] = "CONGRATULATIONS_FREE_BETS_IN_TOTAL_COST";
    TranslationKeys["YouCanUseItTill"] = "YOU_CAN_USE_IT_TILL";
    TranslationKeys["Bet1"] = "BET_1";
    TranslationKeys["OddFreeBet"] = "ODD_FREE_BET";
    TranslationKeys["EndDate"] = "END_DATE";
    TranslationKeys["YourSeedHasBeenSaved"] = "YOUR_SEED_HAS_BEEN_SAVED";
    TranslationKeys["SlowConnection"] = "SLOW_CONNECTION";
    TranslationKeys["DoChipWarning"] = "PLACE_MAIN_BET_FIRST";
    TranslationKeys["Search"] = "SEARCH";
    TranslationKeys["Clear"] = "CLEAR";
    TranslationKeys["NoEmojiFound"] = "NO_EMOJI_FOUND";
    TranslationKeys["SearchResults"] = "SEARCH_RESULTS";
    TranslationKeys["FrequentlyUsed"] = "FREQUENTLY_USED";
    TranslationKeys["FoodAndDrink"] = "FOOD_AND_DRINK";
    TranslationKeys["AnimalsAndNature"] = "ANIMALS_AND_NATURE";
    TranslationKeys["SmileysAndPeople"] = "SMILEYS_AND_PEOPLE";
    TranslationKeys["Activity"] = "ACTIVITY";
    TranslationKeys["TravelAndPlaces"] = "TRAVEL_AND_PLACES";
    TranslationKeys["Objects"] = "OBJECTS";
    TranslationKeys["Symbols"] = "SYMBOLS";
    TranslationKeys["Flags"] = "FLAGS";
    TranslationKeys["Custom"] = "CUSTOM";
    TranslationKeys["EmojiCategories"] = "EMOJI_CATEGORIES";
    TranslationKeys["DefaultSkinTone"] = "DEFAULT_SKIN_TONE";
    TranslationKeys["LightSkinTone"] = "LIGHT_SKIN_TONE";
    TranslationKeys["MediumSkinTone"] = "MEDIUM_SKIN_TONE";
    TranslationKeys["DarkSkinTone"] = "DARK_SKIN_TONE";
    TranslationKeys["ChooseYourDefaultSkinTone"] = "CHOOSE_YOUR_DEFAULT_SKIN_TONE";
    TranslationKeys["MediumLightSkinTone"] = "MEDIUM_LIGHT_SKIN_TONE";
    TranslationKeys["MediumDarkSkinTone"] = "MEDIUM_DARK_SKIN_TONE";
    TranslationKeys["Loading"] = "LOADING";
    TranslationKeys["SomethingWentWrong"] = "SOMETHING_WENT_WRONG";
    TranslationKeys["NoMatchesFound"] = "NO_MATCHES_FOUND";
    TranslationKeys["SearchForGifs"] = "SEARCH_FOR_GIFS";
    TranslationKeys["Chat"] = "CHAT";
    TranslationKeys["Conversation"] = "CONVERSATION";
    TranslationKeys["InsufficientFunds"] = "INSUFFICIENT_FUNDS";
    TranslationKeys["ChooseYourAvatar"] = "CHOOSE_YOUR_AVATAR";
    TranslationKeys["Avatars"] = "AVATARS";
    TranslationKeys["YourSessionWasInterrupted"] = "YOUR_SESSION_WAS_INTERRUPTED";
    TranslationKeys["PlayerLimitExceeded"] = "PLAYER_LIMIT_EXCEEDED";
    TranslationKeys["HalfCashOut"] = "HALF_CASH_OUT";
    TranslationKeys["MaxTicket"] = "MAX_TICKET";
    TranslationKeys["SomethingWentWrong1"] = "SMTH_WENT_WRONG";
    TranslationKeys["NotEnoughFreeBets"] = "NOT_ENOUGH_FREE_BETS";
    TranslationKeys["ChooseContest"] = "CHOOSE_CONTEST";
    TranslationKeys["Continue"] = "CONTINUE";
    TranslationKeys["MinBet"] = "MIN_BET";
    TranslationKeys["MaxBet"] = "MAX_BET";
    TranslationKeys["FreeChip"] = "FREE_CHIP";
    TranslationKeys["YouCanAlsoPlayFollowingGames"] = "YOU_CAN_ALSO_PLAY_FOLLOWING_GAMES";
    TranslationKeys["SilentMode"] = "SILENT_MODE";
    TranslationKeys["Menu"] = "MENU";
    TranslationKeys["Info"] = "INFO";
    TranslationKeys["BalanceBefore"] = "BALANCE_BEFORE";
    TranslationKeys["BalanceAfter"] = "BALANCE_AFTER";
    TranslationKeys["GameTypes"] = "GAME_TYPES";
    TranslationKeys["Home"] = "HOME";
    TranslationKeys["CashOut"] = "CASHOUT";
    TranslationKeys["BetForNextRound"] = "BET_FOR_NEXT_ROUND";
    TranslationKeys["Cancel"] = "CANCEL";
    TranslationKeys["AutoBet"] = "AUTO_BET";
    TranslationKeys["Stop"] = "STOP";
    TranslationKeys["Total"] = "TOTAL";
    TranslationKeys["NumberOfRounds"] = "NUMBER_OF_ROUNDS";
})(TranslationKeys || (TranslationKeys = {}));

export { TranslationKeys };
